<template>
  <v-app>
    <v-app-bar app color="grey darken-2" dark>
      <img src="@/assets/logo-heig-vd.png" alt="Logo HEIG-VD" height="100%" class="logo" />
      <div class="d-flex align-center ml-10">COMMANDES DE PRÉSENTS DE FIN D'ANNÉE</div>
      <v-spacer></v-spacer>
      <user-profile />
    </v-app-bar>

    <v-main>
      <AdminPart />
    </v-main>
  </v-app>
</template>

<script>
import AdminPart from "@/components/AdminPart";
import UserProfile from "@/components/UserProfile";

export default {
  name: "App",

  components: {
    AdminPart,
    UserProfile,
  },
};
</script>

<style>
.logo {
  position: fixed;
  left: 0;
}
</style>
